import {RawTerm} from '../../coreApi/types'
import {Term} from '../../../types'

export const transformTerm = (rawData: RawTerm): Term => ({
  singular: rawData.Singular,
  plural: rawData.Plural,
  singularPossessive: rawData.SingularPossessive,
  pluralPossessive: rawData.PluralPossessive,
})
